/**
 * Scarcity badges — rolling "Offer Ends In" countdown.
 *
 * The window is derived from the epoch (remaining = interval - now % interval), so it restarts on its own every N
 * hours and every visitor sees the same boundary — no cookies, no per-visitor state to store.
 */
(function () {
  if (window.__scarcityBadges) return;
  window.__scarcityBadges = true;

  function paint(timer) {
    var interval = parseInt(timer.getAttribute('data-sb-interval'), 10);
    if (!interval) return;

    var left = interval - (Math.floor(Date.now() / 1000) % interval);
    var units = {
      days: Math.floor(left / 86400),
      hours: Math.floor((left % 86400) / 3600),
      minutes: Math.floor((left % 3600) / 60),
      seconds: left % 60
    };

    Object.keys(units).forEach(function (unit) {
      var chip = timer.querySelector('[data-sb-unit="' + unit + '"]');
      if (!chip) return;
      // days/hours chips are noise on a short window
      if (units[unit] === 0 && (unit === 'days' || (unit === 'hours' && units.days === 0))) {
        chip.hidden = true;
        return;
      }
      chip.hidden = false;
      chip.textContent = units[unit] + unit.charAt(0);
    });
  }

  function tick() {
    document.querySelectorAll('[data-sb-interval]').forEach(paint);
  }

  tick();
  setInterval(tick, 1000);

  // product-rerender swaps the info column on variant change — repaint the fresh markup
  document.addEventListener('variant:change', tick);
})();
